{
  "expo": {
    "scheme": "pokerpower",
    "name": "Poker Power",
    "slug": "poker-power",
    "version": "0.11.4",
    "runtimeVersion": "0.11.4",
    "jsEngine": "hermes",
    "orientation": "portrait",
    "icon": "./assets/icon.png",
    "owner": "ppwr",
    "splash": {
      "image": "./src/assets/splashscreen_image.png",
      "resizeMode": "cover",
      "backgroundColor": "#7B053D"
    },
    "updates": {
      "fallbackToCacheTimeout": 0,
      "url": "https://u.expo.dev/4e5c29d2-c638-4e99-b3ea-20603d1e17ce",
      "enabled": true
    },
    "ios": {
      "usesAppleSignIn": true,
      "supportsTablet": true,
      "bundleIdentifier": "com.pokerpowher.apps.ios",
      "requireFullScreen": true,
      "googleServicesFile": "./config/GoogleService-Info.plist",
      "associatedDomains": [
        "applinks:pokerpower.com",
        "applinks:app.pokerpower.com",
        "applinks:app.sandbox.pokerpower.com",
        "applinks:app.dev.pokerpower.com",
        "applinks:ppwr.io",
        "applinks:dev.ppwr.io",
        "applinks:games.ppwr.io",
        "applinks:games-dev.ppwr.io",
        "applinks:gjva8.app.link",
        "applinks:gjva8-alternate.app.link",
        "applinks:gjva8.test-app.link",
        "applinks:gjva8-alternate.test-app.link",
        "applinks:games.pokerpowherapp.com",
        "applinks:games-dev.pokerpowherapp.com",
        "webcredentials:pokerpower.com",
        "webcredentials:app.pokerpower.com",
        "webcredentials:app.sandbox.pokerpower.com",
        "webcredentials:app.dev.pokerpower.com",
        "webcredentials:ppwr.io",
        "webcredentials:dev.ppwr.io",
        "webcredentials:games.pokerpowherapp.com",
        "webcredentials:games-dev.pokerpowherapp.com"
      ],
      "infoPlist": {
        "NSCameraUsageDescription": "Give Poker Power permission to access your camera",
        "NSMicrophoneUsageDescription": "Give Poker Power permission to use your microphone",
        "NSPhotoLibraryUsageDescription": "Give Poker Power permission to save photos",
        "NSCalendarsUsageDescription": "Poker Power would like to access your calender",
        "NSContactsUsageDescription": "Poker Power would like to access your contacts",
        "NSLocationWhenInUseUsageDescription": "Poker Power would like to access your location",
        "NSRemindersUsageDescription": "Poker Power would like to access your reminders",
        "UIBackgroundModes": [
          "audio",
          "fetch",
          "remote-notification"
        ],
        "LSApplicationQueriesSchemes": [
          "instagram",
          "instagram-stories",
          "whatsapp",
          "instagram",
          "instagram-stories",
          "whatsapp"
        ],
        "ITSAppUsesNonExemptEncryption": false,
        "CFBundleURLTypes": [
          {
            "CFBundleURLName": "com.pokerpowher.apps.ios",
            "CFBundleURLSchemes": [
              "pokerpower",
              "com.pokerpowher.apps.ios",
              "pokerpowher"
            ]
          },
          {
            "CFBundleURLName": "ppwr.io",
            "CFBundleURLSchemes": [
              "ppwr.io"
            ]
          },
          {
            "CFBundleURLName": "dev.ppwr.io",
            "CFBundleURLSchemes": [
              "dev.ppwr.io"
            ]
          },
          {
            "CFBundleURLName": "games.pokerpowherapp.com",
            "CFBundleURLSchemes": [
              "games.pokerpowherapp.com"
            ]
          },
          {
            "CFBundleURLName": "games-dev.pokerpowherapp.com",
            "CFBundleURLSchemes": [
              "games-dev.pokerpowherapp.com"
            ]
          },
          {
            "CFBundleURLName": "app.pokerpower.com",
            "CFBundleURLSchemes": [
              "app.pokerpower.com"
            ]
          },
          {
            "CFBundleURLName": "app.dev.pokerpower.com",
            "CFBundleURLSchemes": [
              "app.dev.pokerpower.com"
            ]
          },
          {
            "CFBundleURLName": "app.sandbox.pokerpower.com",
            "CFBundleURLSchemes": [
              "app.sandbox.pokerpower.com"
            ]
          }
        ]
      }
    },
    "android": {
      "googleServicesFile": "./config/google-services.json",
      "adaptiveIcon": {
        "foregroundImage": "./assets/adaptive-icon.png",
        "backgroundColor": "#7B043D"
      },
      "package": "com.pokerpowher.apps.android",
      "permissions": [
        "android.permission.INTERNET",
        "android.permission.SYSTEM_ALERT_WINDOW",
        "android.permission.VIBRATE",
        "android.permission.CAMERA",
        "android.permission.RECORD_AUDIO",
        "android.permission.READ_EXTERNAL_STORAGE",
        "android.permission.WRITE_EXTERNAL_STORAGE",
        "android.permission.WRITE_SETTINGS",
        "android.permission.ACCESS_NETWORK_STATE",
        "android.permission.WAKE_LOCK",
        "com.google.android.c2dm.permission.RECEIVE",
        "com.google.android.gms.permission.AD_ID",
        "android.permission.POST_NOTIFICATIONS",
        "android.permission.FOREGROUND_SERVICE"
      ]
    },
    "web": {
      "favicon": "./assets/favicon.png",
      "bundler": "metro"
    },
    "extra": {
      "channel": "development",
      "branch": "develop",
      "eas": {
        "projectId": "4e5c29d2-c638-4e99-b3ea-20603d1e17ce"
      }
    },
    "plugins": [
      "expo-dev-client",
      "expo-apple-authentication",
      [
        "react-native-video",
        {
          "androidExtensions": {
            "useExoplayerRtsp": true,
            "useExoplayerSmoothStreaming": true,
            "useExoplayerHls": true,
            "useExoplayerDash": true
          }
        }
      ],
      "expo-font",
      "expo-localization",
      [
        "expo-screen-orientation",
        {
          "initialOrientation": "PORTRAIT_UP"
        }
      ],
      [
        "expo-datadog",
        {
          "errorTracking": {
            "iosDsyms": false,
            "iosSourcemaps": false,
            "androidSourcemaps": false,
            "androidProguardMappingFiles": false
          }
        }
      ],
      "expo-video",
      "@react-native-firebase/app",
      [
        "expo-router",
        {
          "root": "./src/router/"
        }
      ],
      "expo-mail-composer",
      [
        "expo-web-browser",
        {
          "experimentalLauncherActivity": true
        }
      ],
      "expo-background-task",
      [
        "@config-plugins/react-native-branch",
        {
          "apiKey": "key_live_oFckTI3VIRfStxyVy1FxCaliFCpVbtFI",
          "iosUniversalLinkDomains": [
            "games.ppwr.io",
            "gjva8.app.link",
            "gjva8-alternate.app.link",
            "games-dev.ppwr.io",
            "gjva8.test-app.link",
            "gjva8-alternate.test-app.link"
          ]
        }
      ],
      "@react-native-google-signin/google-signin",
      [
        "expo-build-properties",
        {
          "ios": {
            "deploymentTarget": "15.1",
            "useFrameworks": "static"
          },
          "android": {
            "compileSdkVersion": 36,
            "targetSdkVersion": 36,
            "buildToolsVersion": "36.0.0",
            "enableMinifyInReleaseBuilds": true,
            "enableShrinkResourcesInReleaseBuilds": true,
            "extraProguardRules": "# Agora's SDK references a build-time desugar helper that is never shipped at runtime.\n-dontwarn com.google.devtools.build.android.desugar.runtime.ThrowableExtension\n# react-native-device-info loads the Play Install Referrer client by reflection.\n-keep class com.android.installreferrer.api.** { *; }\n# expo-modules-core names its headless JS loader only in AndroidManifest meta-data.\n-keep class expo.modules.adapters.react.apploader.** { *; }"
          }
        }
      ],
      "./plugins/withReactNativeFirebasePodfile.js",
      "./plugins/withFixAppDelegateSwift.js"
    ],
    "experiments": {
      "tsconfigPaths": true,
      "typedRoutes": true
    }
  }
}
